import * as swcHelpers from '@swc/helpers';

/**
 * Maps our settings to an object that's accepted by PowerReviews.display.render() method
 */ const createPowerReviewsConfig = ({ config , locale , productId , variantId , type , id , returnUrl , onRender , onSubmit  })=>swcHelpers.objectSpread({
        enable_content_collection_modal: false,
        api_key: config.apiKey,
        locale: locale.replace('-', '_'),
        merchant_group_id: config.groupId,
        merchant_id: config.opcoId,
        // Append the "?" as PowerReviews doesn't do that but will add query params.
        review_wrapper_url: `${config.writeReviewPath}?`,
        components: {
            [type]: id
        }
    }, productId && {
        page_id: productId
    }, variantId && {
        page_id_variant: variantId
    }, returnUrl && {
        return_url: returnUrl
    }, onRender && {
        on_render: onRender
    }, onSubmit && {
        on_submit: onSubmit
    })
;
/**
 * PowerReviews doesn't accept multiple widgets to be loaded separately.
 * It always expects one object instead of an array or multiple calls to the render fn.
 */ const mergeConfigs = (configs)=>{
    return configs.reduce((result, next)=>swcHelpers.objectSpread({}, result, next, {
            components: swcHelpers.objectSpread({}, result.components, next.components)
        })
    , {});
};

export { createPowerReviewsConfig, mergeConfigs };
//# sourceMappingURL=create-powerreviews-config.js.map
